// =============================================================================
// SIREPPAR - Página informativa para acceso directo a /reempadronamiento
// cuando el período está cerrado (flag VITE_REEMPADRONAMIENTO_HABILITADO=false)
// =============================================================================
import { Link } from 'react-router-dom';
import { TEXTO_CIERRE_REEMPADRONAMIENTO } from '../../utils/cierreReempadronamiento';

export default function ReempadronamientoCerradoPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-900 via-primary-800 to-primary-900 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        {/* Logo y título institucional */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-2xl shadow-xl mb-6">
            <svg className="w-12 h-12 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
          <h1 className="text-4xl font-bold text-white mb-2">SIREPPAR</h1>
          <p className="text-primary-200 text-lg">Sistema de Registro Permanente de Partidos Políticos</p>
          <p className="text-primary-300 text-sm mt-1">Secretaría Electoral Permanente - Provincia del Chubut</p>
        </div>

        {/* Tarjeta informativa */}
        <div className="bg-white rounded-2xl p-10 shadow-xl">
          <div className="flex flex-col items-center text-center">
            <div className="w-20 h-20 bg-gray-100 rounded-2xl flex items-center justify-center mb-6">
              <svg className="w-10 h-10 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-3">REEMPADRONAMIENTO FINALIZADO</h2>

            <p className="text-gray-700 text-base mb-6">
              {TEXTO_CIERRE_REEMPADRONAMIENTO}
            </p>

            <div className="bg-gray-50 border border-gray-200 rounded-lg p-5 mb-8 w-full">
              <p className="text-gray-700 text-sm mb-2">
                Por consultas comuníquese con el <strong>Área de Registro de Partidos Políticos</strong> al correo:
              </p>
              <a
                href="mailto:registro@electoralchubut.gob.ar"
                className="text-primary-700 font-medium hover:text-primary-900 underline break-all"
              >
                registro@electoralchubut.gob.ar
              </a>
            </div>

            <Link
              to="/"
              className="inline-flex items-center px-6 py-3 bg-primary-600 text-white rounded-xl font-medium hover:bg-primary-700 transition"
            >
              <svg className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Volver al inicio
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
